$(document).ready(function () {

    let storeContent = localStorage.getItem('store-content');

    if (storeContent === 'cloth') {
        $('body').addClass('cloth');
        $('.switch-content-main input').attr('checked', true);
    }else{
        $('body').addClass('shoes');
        $('.switch-content-main input').attr('checked', false);
    }

  $(document).on("change", ".switch-content-main input", function (e) {
    if ($(this).is(":checked")) {
        localStorage.setItem('store-content', 'cloth');
        // remove class and add new class in body
        //$('body').removeClass('shoes').addClass('cloth');
    } else {
        localStorage.setItem('store-content', 'shoes');
        // remove class and add new
        //$('body').removeClass('cloth').addClass('shoes');
    }
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('s');
    if (myParam == 'dorfasthetik') {
        // remove query string
        window.location.href = window.location.href.split('?')[0];
    }else{
        location.reload();
    }
  });
});
